import styled from 'styled-components'

export const Container = styled.section`
  padding-top: 6rem;
  padding-bottom: 2rem;
  position: relative;

  .grade-vertical {
    position: absolute;
    z-index: -99;

    left: 0;
    width: 6rem;
    @media (max-width: 767.98px) {
      width: 2rem;
    }

    @media screen and (max-width: 1500px) {
      display: none;
    }
  }

  .lobby {
    position: absolute;
    max-width: 47rem;
    right: 0;

    z-index: -1;
  }
  @media (min-width: 1566px) {
    .lobby {
      max-width: 65rem;
    }
  }
`

export const LocationContent = styled.div`
  padding: 1rem;
  margin: 0 auto;
  width: 100%;
  max-width: 80rem;

  .fancy-text-container {
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .fancy-text-bg {
    position: absolute;
    background-color: #9bc742;
    height: 40%;
    width: 95%;
    z-index: 10;
    @media screen and (max-width: 1000px) {
      background-color: transparent;
    }
  }

  .fancy-text {
    left: 0;
    width: 100%;
    z-index: 99;
    background-color: transparent;
    font-size: 2.5rem !important;
    font-family: 'Sacramento';
  }

  .mapa {
    max-width: 25rem;
    width: 100%;
  }

  .description-content {
    max-width: 24rem;
    h2 {
      color: var(--shape-color);
      font-size: 2.2rem;
      font-weight: bold;
    }
    p {
      color: white;
      font-size: 1rem;
      text-align: justify;
      @media (max-width: 1000px) {
        background-color: rgb(203, 143, 85, 0.9);
        padding: 1rem;
        color: var(--shape-color);
      }
    }
  }
  .footer-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap-reverse;
    align-items: center;

    @media screen and (max-width: 850px) {
      justify-content: center;
      margin-top: 20rem;

      .description {
        margin-bottom: 2rem;
      }
    }

    @media screen and (min-width: 1560px) {
      .description {
      }
    }
  }

  @media (min-width: 1566px) {
    .footer-content {
      align-items: end;
    }
  }

  @media (max-width: 575.98px) {
    .footer-content {
      margin-top: 8rem;
      justify-content: center;
    }
  }
`

